import { useNavigate, useParams } from 'react-router-dom';

const useUserSearch = () => {
  const { userId } = useParams();
  const navigate = useNavigate();

  const userSelected = (selectedUserId: string) => {
    if (selectedUserId === userId) {
      return;
    }
    void navigate(`/users/${selectedUserId}`);
  };

  return {
    userId,
    userSelected
  };
};

export default useUserSearch;
